import { CameraIcon } from './CameraIcon';

/**
 * author: Google
 * id 236D9E8E-E38C-4EA9-9539-0E8B1447003A
 * name camera
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera.svg
 * tags
 * - Photography 
 * - Home Automation 
 */
export const CameraAltIcon = CameraIcon;
export default CameraAltIcon